// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmailSignatureTemplateRequest {
    static getAttributeTypeMap() {
        return EmailSignatureTemplateRequest.attributeTypeMap;
    }
}
EmailSignatureTemplateRequest.discriminator = undefined;
EmailSignatureTemplateRequest.additionalProperties = false;
EmailSignatureTemplateRequest.attributeTypeMap = [
    {
        "name": "brandId",
        "baseName": "brandId",
        "type": "string"
    },
    {
        "name": "senderId",
        "baseName": "senderId",
        "type": "string"
    },
    {
        "name": "templateId",
        "baseName": "templateId",
        "type": "string"
    },
    {
        "name": "recipients",
        "baseName": "recipients",
        "type": "Array<QpsignatureRecipient>"
    },
    {
        "name": "emailSubject",
        "baseName": "emailSubject",
        "type": "string"
    },
    {
        "name": "emailBody",
        "baseName": "emailBody",
        "type": "string"
    },
    {
        "name": "fields",
        "baseName": "fields",
        "type": "Array<QpsignatureField>"
    },
    {
        "name": "documentType",
        "baseName": "documentType",
        "type": "string"
    },
    {
        "name": "attestations",
        "baseName": "attestations",
        "type": "Array<QpsignatureAttestation>"
    },
    {
        "name": "expireInDays",
        "baseName": "expireInDays",
        "type": "number"
    },
];
//# sourceMappingURL=emailSignatureTemplateRequest.js.map